import { render, staticRenderFns } from "./shortcut.vue?vue&type=template&id=c5dec072&scoped=true"
import script from "./shortcut.vue?vue&type=script&lang=js"
export * from "./shortcut.vue?vue&type=script&lang=js"
import style0 from "./shortcut.vue?vue&type=style&index=0&id=c5dec072&prod&lang=scss&scoped=true"
import style1 from "./shortcut.vue?vue&type=style&index=1&id=c5dec072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dec072",
  null
  
)

export default component.exports